/*!
 * Attaches Performance Timing data to Snowplow events v3.23.1 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */
function PerformanceTimingPlugin() {
  function getPerformanceTimingContext() {
    var windowAlias = window, performanceAlias = windowAlias.performance || windowAlias.mozPerformance || windowAlias.msPerformance || windowAlias.webkitPerformance, performanceTimingAlias = performanceAlias.timing;
    if (performanceAlias) {
      var performanceTiming = {
        navigationStart: performanceTimingAlias.navigationStart,
        redirectStart: performanceTimingAlias.redirectStart,
        redirectEnd: performanceTimingAlias.redirectEnd,
        fetchStart: performanceTimingAlias.fetchStart,
        domainLookupStart: performanceTimingAlias.domainLookupStart,
        domainLookupEnd: performanceTimingAlias.domainLookupEnd,
        connectStart: performanceTimingAlias.connectStart,
        secureConnectionStart: performanceTimingAlias.secureConnectionStart,
        connectEnd: performanceTimingAlias.connectEnd,
        requestStart: performanceTimingAlias.requestStart,
        responseStart: performanceTimingAlias.responseStart,
        responseEnd: performanceTimingAlias.responseEnd,
        unloadEventStart: performanceTimingAlias.unloadEventStart,
        unloadEventEnd: performanceTimingAlias.unloadEventEnd,
        domLoading: performanceTimingAlias.domLoading,
        domInteractive: performanceTimingAlias.domInteractive,
        domContentLoadedEventStart: performanceTimingAlias.domContentLoadedEventStart,
        domContentLoadedEventEnd: performanceTimingAlias.domContentLoadedEventEnd,
        domComplete: performanceTimingAlias.domComplete,
        loadEventStart: performanceTimingAlias.loadEventStart,
        loadEventEnd: performanceTimingAlias.loadEventEnd,
        msFirstPaint: performanceTimingAlias.msFirstPaint,
        chromeFirstPaint: performanceTimingAlias.chromeFirstPaint,
        requestEnd: performanceTimingAlias.requestEnd,
        proxyStart: performanceTimingAlias.proxyStart,
        proxyEnd: performanceTimingAlias.proxyEnd
      };
      return [
        {
          schema: "iglu:org.w3/PerformanceTiming/jsonschema/1-0-0",
          data: performanceTiming
        }
      ];
    }
    return [];
  }
  return {
    contexts: function() {
      return getPerformanceTimingContext();
    }
  };
}
export {
  PerformanceTimingPlugin
};
